import React from 'react';
import DivSX, { DivSXProps } from 'tradevan-ui/@emotion/DivSX';
import { classCombine } from 'tradevan-ui/consts';

const EditForm = (props: DivSXProps): JSX.Element => {
  const { className, children, sx, ...other } = props;
  return (
    <DivSX
      className={classCombine(`edit-form`, className)}
      sx={{ position: 'initial', ...sx }}
      {...other}
    >
      {children}
    </DivSX>
  );
};

export default EditForm;
